import React from "react";

import { Box } from "@dxp-feed/ui/Box";
import { Button } from "@dxp-feed/ui/Button";
import { SlidePanel } from "@dxp-feed/ui/SlidePanel";
import { Text } from "@dxp-feed/ui/Text";
import { useState } from "@/utils/hooks/reactUseCustomHooks";
import Link from "@/components/Link";
import FeaturedOffersSlider from "./JustForYouOffers/featuredOffersSlider";
import OfferCard from "@/components/OfferCard";
import Loader from "@/components/Loader";

interface GroupOffersProps {
  posOfferData: any;
  isPanelOpen: boolean;
  setIsPanelOpen: (isOpen: boolean) => void;
  offers: any;
}

export default function GroupOffers({
  isPanelOpen,
  posOfferData,
  setIsPanelOpen,
  offers,
}: GroupOffersProps) {
  return (
    <>
      <Box as="div">
        <SlidePanel
          side="right"
          isOpen={isPanelOpen}
          className="w-full max-w-[756px]"
        >
          <Box as="div" className="p-0">
            <Box
              as="div"
              className="relative top-0 left-0 right-0 bg-white z-[2]"
            >
              <Box
                as="div"
                className="flex items-center justify-between p-6 border-b-1	border-b border-neutral200"
              >
                <Box as="div">
                  <Box as="div" className="text-base text-black font-bold pr-[10px]">
                    Great news! This product is part of a special group offer.
                  </Box>
                </Box>
                <Button
                  className="text-gray-500 font-bold text-lg w-[20px]"
                  onClick={() => setIsPanelOpen(false)}
                  aria-label="Close modal"
                  variant="icon"
                  size="none"
                >
                  <Text
                    as="span"
                    className="icon-close text-neutral900 text-[14px]"
                  ></Text>
                </Button>
              </Box>
            </Box>
            <Box as="div" className="p-6">
              <Box as="div" className="text-body text-black mb-6 text-left">
                Buy any {posOfferData?.[0]?.rewardArticalID?.length} eligible
                products and earn{" "}
                <strong>{offers?.points} Scene+ Points!</strong>
              </Box>
              <Box
                as="div"
                className="grid grid-cols-1 2xs:grid-cols-2 md:grid-cols-3 gap-[8px] xs:gap-[16px] lg:gap-[24px] overflow-y-auto max-h-[calc(100vh-220px)] md:max-h-[calc(100vh-150px)] pb-[100px] px-[2px] pt-[2px]"
              >
                {/* <GroupOffersSlider/> */}
                {posOfferData.length > 0 ? (
                  posOfferData.map((item: any) => (
                    <OfferCard key={item.objectID} item={item} isOpen={true} isLoaded={true} />
                  ))
                ) : (
                  <Box
                    as="div"
                    className="w-full text-center flex items-center justify-center absolute left-0 right-0 top-0 bottom-0 mx-auto"
                  >
                    <Loader />
                  </Box>
                )}
              </Box>
            </Box>

            <Box
              as="div"
              className="flex bg-white shadow-[0_-3px_7px_0_rgba(0,0,0,0.28)] pt-3 px-2 2xs:px-6 !py-[12px] absolute bottom-0 left-0 right-0 h-[68.78px] z-[2]"
            >
              <Box
                as="div"
                className="w-full flex items-center justify-end gap-0"
              >
                <Button
                  variant="icon"
                  className="text-body underline hover:no-underline font-semibold text-green border-none"
                  onClick={() => setIsPanelOpen(false)}
                >
                  Continue Shopping
                </Button>
                <Button
                  variant="primary"
                  className="font-normal !text-body !px-2 !4xs:px-4"
                  onClick={() => window?.location?.pathname == "/shopping-list" && setIsPanelOpen(false)}
                >
                  <Link href="/manage-list">View Shopping List</Link>
                </Button>
              </Box>
            </Box>
          </Box>
        </SlidePanel>
      </Box>
    </>
  );
}
